// Dev stub for file upload integration used by SubsidiaryForm.
// Replace with your real storage integration.
export async function UploadFile({ file }: { file: File }): Promise<{ file_url: string }> {
  // In dev, pretend upload and return an object URL
  const file_url = URL.createObjectURL(file)
  return { file_url }
}

